<mat-form-field [hideRequiredMarker]="hideRequiredMarker"
                [ngClass]="fieldClass">
  <mat-label>{{ label }}</mat-label>
  <mat-icon fontSet="flag-icon"
            [fontIcon]="flagIcon"
            [class.disabled]="isFlagDisabled"
            [matTooltip]="countryFlagTooltip || ''"
            [matTooltipDisabled]="!countryFlagTooltip"
            matTooltipPosition="above"
            matIconPrefix></mat-icon>
  <app-mat-phone-input [formControl]="phoneControl"
                       [placeholder]="placeholder"
                       [campaignCountry]="campaignCountry"
                       (countryCodeEvent)="updateFlagIcon($event)"></app-mat-phone-input>
  <app-input-error [formControlItem]="phoneControl"></app-input-error>
</mat-form-field>
